import { render, staticRenderFns } from "./EditPenIcon.vue?vue&type=template&id=49c546d3"
import script from "./EditPenIcon.vue?vue&type=script&lang=ts"
export * from "./EditPenIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c546d3')) {
      api.createRecord('49c546d3', component.options)
    } else {
      api.reload('49c546d3', component.options)
    }
    module.hot.accept("./EditPenIcon.vue?vue&type=template&id=49c546d3", function () {
      api.rerender('49c546d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/EditPenIcon.vue"
export default component.exports